import { useSelector } from "react-redux";

export const IsFeatureEnabledOrNot = (featureName) => {
  const featureToggleList = useSelector(
    (rootState) => rootState.featureToggleList.featureToggleList.value?.data
  );
  let featureEnabled = false;
  if (featureToggleList !== undefined) {
    featureToggleList.forEach((feature) => {
      if (feature.featureName === featureName) {
        featureEnabled = feature.isFeatureEnabled;
      }
    });
    return featureEnabled;
  }
  return featureEnabled;
};
